import { lazy, Suspense } from 'react';
import Home from '@/pages/Home';
import { LoadingOutlined } from '@ant-design/icons';

// 路由懒加载
const PusherWrap = lazy(() => import('@/pages/PusherWrap'));
const PlayerWrap = lazy(() => import('@/pages/PlayerWrap'));
const PusherGlobal = lazy(() => import('@/pages/PusherGlobal'));
const PusherSingle = lazy(() => import('@/pages/PusherSingle'));
const GlobalMulti = lazy(() => import('@/pages/GlobalMulti'));
const PusherLite = lazy(() => import('@/pages/PusherLite'));
const PusherOBS = lazy(() => import('@/pages/PusherOBS'));
const PusherField = lazy(() => import('@/pages/PusherField'));
const Player = lazy(() => import('@/pages/Player'));
const Material = lazy(() => import('@/pages/Material'));

const withLoadingComponent = (comp: JSX.Element) => (
  <Suspense fallback={<div className="loading"><LoadingOutlined /></div>}>
    {comp}
  </Suspense>
);

const ROUTES = [
  {
    path: '/',
    element: withLoadingComponent(<Home />),
  },
  {
    path: '/pusher-v2', // 旧版个人推流路由 (仅用于保留过渡)
    element: withLoadingComponent(<PusherWrap />),
    children: [
      {
        path: '/pusher-v2',
        element: withLoadingComponent(<PusherSingle />),
      },
    ],
  },
  {
    path: '/pusher-global', // 全局推流
    element: withLoadingComponent(<PusherWrap />),
    children: [
      {
        path: '/pusher-global',
        element: withLoadingComponent(<PusherGlobal />),
      },
    ],
  },
  {
    path: '/pusher-single', // 个人推流
    element: withLoadingComponent(<PusherWrap />),
    children: [
      {
        path: '/pusher-single',
        element: withLoadingComponent(<PusherSingle />),
      },
    ],
  },
  {
    path: '/pusher-field', // 外带拍手推流
    element: withLoadingComponent(<PusherWrap />),
    children: [
      {
        path: '/pusher-field',
        element: withLoadingComponent(<PusherField />),
      },
    ],
  },
  {
    path: '/global-multi', // 全局多路推流 (for PTeam)
    element: withLoadingComponent(<PusherWrap />),
    children: [
      {
        path: '/global-multi',
        element: withLoadingComponent(<GlobalMulti />),
      },
    ],
  },
  {
    path: '/pusher-lite', // 轻量推流 (for PTeam)
    element: withLoadingComponent(<PusherWrap />),
    children: [
      {
        path: '/pusher-lite',
        element: withLoadingComponent(<PusherLite />),
      },
    ],
  },
  {
    path: '/pusher-obs', // 控制OBS推流页面 (for PTeam)
    element: withLoadingComponent(<PusherWrap />),
    children: [
      {
        path: '/pusher-obs',
        element: withLoadingComponent(<PusherOBS />),
      },
    ],
  },
  {
    path: '/player', // 小黑屋观看端
    element: withLoadingComponent(<PlayerWrap />),
    children: [
      {
        path: '/player',
        element: withLoadingComponent(<Player />),
      },
    ],
  },
  {
    path: '/material', // 素材测试
    element: withLoadingComponent(<Material />),
  },
];

export default ROUTES;
